import { Injectable, OnDestroy } from '@angular/core';
import {
  AuthorizationHeader,
  CallInfoHeader,
  CallSettingsHeader,
  HeaderTypes,
  ICallHeader,
  LicenseHeader,
  SessionInfoHeader,
  XApiKeyHeader
} from '../models/headers';

@Injectable({
  providedIn: 'root'
})
export class HeaderService implements OnDestroy {
  cache = new Map();

  constructor() {}

  ngOnDestroy(): void {
    this.cache.clear();
  }

  public getHeader(headerType: HeaderTypes): ICallHeader {
    if (this.cache.has(headerType)) {
      return this.cache.get(headerType);
    } else {
      const header = this.createHeader(headerType);
      this.cache.set(headerType, header);
      return header;
    }
  }

  public setHeader(headerType: HeaderTypes, headerValue: ICallHeader) {
    this.cache.set(headerType, headerValue);
  }

  private createHeader(headerType: HeaderTypes): ICallHeader {
    switch (headerType) {
      case HeaderTypes.ApiKey:
        return new XApiKeyHeader();
      case HeaderTypes.CallSettings:
        return new CallSettingsHeader();
      case HeaderTypes.License:
        return new LicenseHeader();
      case HeaderTypes.SessionInfo:
        return new SessionInfoHeader();
      case HeaderTypes.CallInfo:
        return new CallInfoHeader();
      case HeaderTypes.Authorization:
        return new AuthorizationHeader();
    }
    return null;
  }
}
